import Handlebars from 'handlebars';
import axios from 'axios';

function handleCart() {
  const cartData = {};
  const cartDrawer = document.querySelector('#CartContainer > form');
  const qtySource = document.querySelector('#JsQty').innerHTML;
  const qtyTemplate = Handlebars.compile(qtySource);
  const cartFooterSource = document.querySelector('#JsCartFooter').innerHTML;
  const cartFooterTemplate = Handlebars.compile(cartFooterSource);
  const navCartButton = document.getElementById('js-nav-cart');


  navCartButton.addEventListener('click', () => {
    const resultArr = [];


    axios.get(`${window.location.origin}/cart.js`).then((data) => {
      data.data.items.forEach((item) => {
        cartData.key = item.key;
        cartData.inputId = `updates_${item.key}`;
        cartData.itemQty = item.quantity;
        cartData.inputName = 'updates[]';
        cartData.img = item.image;
        cartData.productTitle = item.product_title;
        resultArr.push(qtyTemplate(cartData));
      });



      cartDrawer.innerHTML = resultArr.join('') + cartFooterTemplate();
      const productCounts = Array.from(document.querySelectorAll('.js-qty__num'));
      const minusButtons = Array.from(document.querySelectorAll('.js-qty__adjust--minus'));
      const addButtons = Array.from(document.querySelectorAll('.js-qty__adjust--plus'));


      minusButtons.forEach((item, i) => {
        item.addEventListener('click', () => {
          productCounts[i].value = Number(productCounts[i].value) - 1;
          axios.post(`${window.location.origin}/cart/change.js`, {
            quantity: productCounts[i].value,
            id: data.data.items[i].key
          });
        }, false);
      });



      addButtons.forEach((item, i) => {
        item.addEventListener('click', () => {
          productCounts[i].value = Number(productCounts[i].value) + 1;
          axios.post(`${window.location.origin}/cart/add.js`, {
            quantity: 1,
            id: data.data.items[i].variant_id
          });
        }, false);
      });
    }).catch((error) => {
      console.warn(error);
    });
  }, false);
}

export default handleCart;
